import { React } from 'react'
import { Modal } from 'rsuite'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import background from '../Components/Styles/images/404.png'
import '../Components/Styles/navigation-bar.css'
import { colors } from '../Components/Styles/common-styles'
import { AddToEventButton as HomeButton } from '../Components/Activity/ActivityStyledComponents'

const Background = styled.div`
    height: 100vh;
    background-image: url(${background});
    background-size: cover;
`

const NotFound = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 560px;
    height: 506px;
    background: ${colors.white};
    border-radius: 8px;
`

const StatusCode = styled.div`
    font-size: 144px;
    font-weight: 600;
    line-height: 183px;
    letter-spacing: 4px;
    color: ${colors.grey}
`

const StatusText = styled.div`
    font-size: 36px;
    font-weight: 400;
    line-height: 46px;
    letter-spacing: 0px;
    color: ${colors.black}
`

const MyModal = styled(Modal)`
-webkit-animation: slide-in 0.7s forwards;
.rs-modal-dialog {
    margin-left: 0;
    margin-right: 0;
},
.rs-modal-content {
    background-color: ${colors.highlighter};
}
`

const NotFound404 = () => {
  return (
    <MyModal show full>
      <Background>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex' }}>
            <Link to='/' style={{ color: colors.purpleMain, margin: '26px 127px' }}>
              <div className='brand-name'>
                <span className='taito'>TAITO</span>
                <span className='training'>TRAINING</span>
              </div>
            </Link>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <NotFound>
              <StatusCode>404</StatusCode>
              <StatusText>Ooops! Page not found.</StatusText>
              <Link style={{ marginTop: '65px' }} to='/'>
                <HomeButton>Go home</HomeButton>
              </Link>
            </NotFound>
          </div>
        </div>
      </Background>
    </MyModal>
  )
}

export default NotFound404
